import {DmsMetadataSchema} from "../../model/dmsMetadataSchema";

export interface FormWorkflowState {
  sendContents: { [id: number]: {comment: string, metadata: Array<DmsMetadataSchema> }};
}

export const initialFormWorkflowState: FormWorkflowState = {
  sendContents: {},
};
